import React, { useEffect } from "react";
import "./Re_Order.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import Vertical_Tracker from "../Common-Component/Vertical_Tracker/Vertical_Tracker";
import Select_Dropdown_holder from "../Common-Component/Select_Dropdown_holder/Select_Dropdown_holder";
import Inclusive_taxes from "./Inclusive_taxes/Inclusive_taxes";
import Pincode_section from "./Pincode_section/Pincode_section";
import Delivery_options from "./Delivery_options/Delivery_options";
import { Controller, useForm } from "react-hook-form";
import {
  findCombination,
  getProduct,
} from "../../features/products/productsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Vertical_Tracker_Cart from "../Common-Component/Vertical_Tracker/Vertical_Tracker_Cart";

function Re_Order({}) {
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "ORDER", link: "/my-order" },
    { name: "RE ORDER" },
  ];

  const stepList = [
    "Customise Business Cards",
    "Design Business Card",
    "Confirm & Add to Cart",
    "Cart",
  ];

  const dropdownOptions = [
    "Materials",
    "Lamination",
    "Orientation",
    "Printing Location",
    "Quantity",
  ];

  const options = [
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];
  const dispatch = useDispatch();
  const { id } = useParams();
  const product = useSelector((state) => state.product.product);
  useEffect(() => {
    if (id) {
      // Ensure ID is valid before dispatching
      dispatch(getProduct(id));
    }
  }, [dispatch, id]);
  const [combination, setCombination] = useState({});
  const [error, setError] = useState();
  const [pincode, setPincode] = useState();
  const handleMaterialChange = (selected) => {
    setValue("material_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleLaminationChange = (selected) => {
    setValue("lamination_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleOrientationChange = (selected) => {
    setValue("orientation_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleEnvelopeChange = (selected) => {
    setValue("envelop_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handlePrintLocationChange = (selected) => {
    setValue("print_location_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleSizeChange = (selected) => {
    setValue("size_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const handleRoundCornerhange = (selected) => {
    setValue("round_corner", selected?.value === "Yes" ? 1 : 0);
    handleSubmit(onSubmit)();
  };

  const handleQuantityhange = (selected) => {
    setValue("quantity_id", selected?.value);
    handleSubmit(onSubmit)();
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    getValues,
    trigger,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
    const res = await dispatch(findCombination(data));
    if (res?.payload?.errors) {
      setError(res?.payload?.errors);
    }
    await setCombination(res?.payload?.data);

 
  };

  useEffect(() => {
    if (product?.Product_Combinations?.length) {
      reset(product.Product_Combinations[0]);
      handleSubmit(onSubmit)();
    }
  }, [product, reset]);
  return (
    <section className="Re_Order">
      <div className="custom_container">
        <div className="breadcrump_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={breadcrumbData} />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3 col-md-4">
            <Vertical_Tracker_Cart steps={stepList.map((label) => ({ label }))} />
          </div>

          <div className="col-lg-6 col-md-7">
            <div className="text_holder">
              <h4>Customise Business Cards</h4>
              <p>
                Leave a memorable mark in every interaction with our bespoke
                business cards. Networking made impactful for SMBs.
              </p>
            </div>

            <div className="select_holder">
              {product?.Category?.material && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Materials</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="material_id" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            {...field}
                            option={[
                              ...new Map(
                                product?.Product_Combinations?.map((val) => [
                                  val?.material_id,
                                  {
                                    value: val?.material_id,
                                    label: val?.Material?.name,
                                  },
                                ])
                              ).values(),
                            ]}
                            handleChange={handleMaterialChange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {product?.Category?.orientation && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Orientation</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="orientation_id" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            option={[
                              ...new Map(
                                product?.Product_Combinations?.map((val) => [
                                  val?.orientation_id,
                                  {
                                    value: val?.orientation_id,
                                    label: val?.Orientation?.name,
                                  },
                                ])
                              ).values(),
                            ]}
                            handleChange={handleOrientationChange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {product?.Category?.printing_location && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Printing Location</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="print_location_id" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            option={[
                              ...new Map(
                                product?.Product_Combinations?.map((val) => [
                                  val?.print_location_id,
                                  {
                                    value: val?.print_location_id,
                                    label: val?.PrintingLocation?.name,
                                  },
                                ])
                              ).values(),
                            ]}
                            handleChange={handlePrintLocationChange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {product?.Category?.quantity && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Quantity</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="quantity_id" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            option={[
                              ...new Map(
                                product?.Product_Combinations?.map((val) => [
                                  val?.quantity_id,
                                  {
                                    value: val?.quantity_id,
                                    label: val?.Qty?.name,
                                  },
                                ])
                              ).values(),
                            ]}
                            handleChange={handleQuantityhange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {product?.Category?.size && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Size</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="size_id" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            option={[
                              ...new Map(
                                product?.Product_Combinations?.map((val) => [
                                  val?.size_id,
                                  {
                                    value: val?.size_id,
                                    label: val?.Size?.name,
                                  },
                                ])
                              ).values(),
                            ]}
                            handleChange={handleSizeChange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {product?.Category?.envelope && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Envelope</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="envelope_id" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            option={[
                              ...new Map(
                                product?.Product_Combinations?.map((val) => [
                                  val?.envelope_id,
                                  {
                                    value: val?.envelope_id,
                                    label: val?.Envelope?.name,
                                  },
                                ])
                              ).values(),
                            ]}
                            handleChange={handleEnvelopeChange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
              {product?.Category?.round_corner && (
                <div className="material_select_dropdown">
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="title_holder">
                        <h4>Round Corner</h4>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <Controller
                        name="round_corner" // Form field name
                        control={control}
                        render={({ field }) => (
                          <Select_Dropdown_holder
                            option={options}
                            handleChange={handleRoundCornerhange}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <Inclusive_taxes pincode={pincode} combination={combination} product={product} />
            <Pincode_section product={product} pincode={pincode} setPincode={setPincode} />
            <Delivery_options
              imgSrc={"/assets/Images/Icons/Delivery_img_1.png"}
              headingText={"Express Delivery:"}
              describe={
                "4 Hours/Same Day Delivery Available At Selected Locations."
              }
            />
            <Delivery_options
              imgSrc={"/assets/Images/Icons/Delivery_img_2.png"}
              headingText={"Standard Delivery:"}
              describe={"Estimated Delivery By Thu, 13 Feb"}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Re_Order;
